// packages/apps/patterns/react-icons/src/icons/DXNS.tsx
import { IconBase } from "@phosphor-icons/react";
import React, { forwardRef } from "react";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var weights = /* @__PURE__ */ new Map([
  [
    "regular",
    // eslint-disable-next-line react/jsx-key
    /* @__PURE__ */ React.createElement("g", {
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2
      }
    }, /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M49.285,99.535L227.063,266.206L233.754,269.776L709.185,379.616L722.442,376.046L1017.38,99.535L1007.41,74.313L59.259,74.313L49.285,99.535M96.137,103.479L244.146,242.242L708.169,349.446L970.53,103.479L96.137,103.479"
    })), /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M240.121,269.814L1010.49,103.142L1004.32,74.635L233.953,241.306L240.121,269.814Z"
    })), /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M533.327,513.34L702.487,354.763L722.435,376.042L543.301,543.969L523.353,543.968L227.057,266.202L247.004,244.923L533.327,513.34Z"
    })), /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M59.259,992.354L1007.41,992.354L1017.38,967.132L722.442,690.621L709.185,687.051L233.754,796.891L227.063,800.461L49.285,967.132L59.259,992.354M244.146,824.425L96.137,963.187L970.53,963.187L708.169,717.221L244.146,824.425"
    })), /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M233.953,825.36L1004.32,992.031L1010.49,963.524L240.121,796.853L233.953,825.36Z"
    })), /* @__PURE__ */ React.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M533.327,553.328L247.004,821.745L227.057,800.466L523.353,522.7L543.301,522.7L722.435,690.626L702.487,711.905L533.327,553.328Z"
    })))
  ]
]);
var DXNSIcon = /* @__PURE__ */ forwardRef((props, ref) => /* @__PURE__ */ React.createElement(IconBase, _extends({
  ref
}, props, {
  weights
})));
DXNSIcon.displayName = "DXOS";
var DXNS_default = DXNSIcon;

// packages/apps/patterns/react-icons/src/icons/DXOS.tsx
import { IconBase as IconBase2 } from "@phosphor-icons/react";
import React2, { forwardRef as forwardRef2 } from "react";
function _extends2() {
  _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var weights2 = /* @__PURE__ */ new Map([
  [
    "regular",
    /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement("path", {
      d: "M127.96,85.307l2.83,-2.058l113.742,156.395l-4.684,5.025l-111.888,-69.93l-111.888,69.93l-4.684,-5.025l113.742,-156.395l2.83,2.058Zm100.309,143.873l-100.309,-137.925l-100.309,137.925l98.455,-61.534l3.708,0l98.455,61.534Z"
    }), /* @__PURE__ */ React2.createElement("path", {
      d: "M127.96,81.181l111.888,-69.93l4.684,5.025l-113.742,156.395l-2.83,-2.058l-2.83,2.058l-113.742,-156.395l4.684,-5.025l111.888,69.93Zm-100.309,-54.441l100.309,137.925l100.309,-137.925l-98.455,61.534l-3.708,-0l-98.455,-61.534Z"
    }), /* @__PURE__ */ React2.createElement("rect", {
      x: "124.467",
      y: "85.307",
      width: "6.998",
      height: "85.307"
    }))
  ]
]);
var DXOSIcon = /* @__PURE__ */ forwardRef2((props, ref) => /* @__PURE__ */ React2.createElement(IconBase2, _extends2({
  ref
}, props, {
  weights: weights2
})));
DXOSIcon.displayName = "DXOS";
var DXOS_default = DXOSIcon;

// packages/apps/patterns/react-icons/src/icons/ECHO.tsx
import { IconBase as IconBase3 } from "@phosphor-icons/react";
import React3, { forwardRef as forwardRef3 } from "react";
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var weights3 = /* @__PURE__ */ new Map([
  [
    "regular",
    /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement("path", {
      d: "M20.206,95.214l213.266,72.121l2.242,-6.628l-213.266,-72.123l-2.242,6.63Z"
    }), /* @__PURE__ */ React3.createElement("path", {
      d: "M233.472,88.584l-213.266,72.123l2.242,6.628l213.266,-72.121l-2.242,-6.63Z"
    }), /* @__PURE__ */ React3.createElement("path", {
      d: "M127.96,122.86l104.017,-111.034l6.053,2.392l-0.034,227.485l-6.053,2.391l-103.983,-110.998l-103.983,110.998l-6.053,-2.391l-0.033,-227.485l6.052,-2.392l104.017,111.034Zm4.795,5.118l98.244,104.873l0.032,-209.779l-98.276,104.906Zm-107.834,104.873l98.245,-104.873l-98.276,-104.906l0.031,209.779Z"
    }))
  ]
]);
var ECHOIcon = /* @__PURE__ */ forwardRef3((props, ref) => /* @__PURE__ */ React3.createElement(IconBase3, _extends3({
  ref
}, props, {
  weights: weights3
})));
ECHOIcon.displayName = "DXOS";
var ECHO_default = ECHOIcon;

// packages/apps/patterns/react-icons/src/icons/HALO.tsx
import { IconBase as IconBase4 } from "@phosphor-icons/react";
import React4, { forwardRef as forwardRef4 } from "react";
function _extends4() {
  _extends4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var weights4 = /* @__PURE__ */ new Map([
  [
    "regular",
    /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement("path", {
      d: "M95.822,117.241l-64.269,126.05l-6.235,-3.178l65.243,-127.96l3.117,-1.91l65.243,0l0,6.998l-63.099,0Z"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M227.483,241.703l-68.559,-127.96l68.559,127.96Z"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M230.567,240.05l-6.168,3.305l-68.559,-127.96l6.168,-3.305l68.559,127.96Z"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M230.569,240.05l-68.563,-127.96l-6.169,3.305l68.563,127.96l6.169,-3.305Z"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M158.921,113.742l-32.621,56.871"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M155.886,112.001l-32.621,56.871l6.07,3.482l32.621,-56.871l-6.07,-3.482Z"
    }), /* @__PURE__ */ React4.createElement("path", {
      d: "M184.275,30.24l-21.968,84.384l-6.772,-1.764l25.91,-99.524l6.825,0.237l42.654,227.484l-5.451,3.508l-99.139,-69.652l-95.842,69.62l-5.495,-3.476l42.653,-227.484l6.851,-0.13l22.474,99.013l31.973,55.741l93.513,65.7l-38.186,-203.657Zm-112.86,1.223l-37.92,202.239l88.207,-64.073l-31.059,-54.146l-0.377,-0.967l-18.851,-83.053Z"
    }))
  ]
]);
var HALOIcon = /* @__PURE__ */ forwardRef4((props, ref) => /* @__PURE__ */ React4.createElement(IconBase4, _extends4({
  ref
}, props, {
  weights: weights4
})));
HALOIcon.displayName = "DXOS";
var HALO_default = HALOIcon;

// packages/apps/patterns/react-icons/src/icons/KUBE.tsx
import { IconBase as IconBase5 } from "@phosphor-icons/react";
import React5, { forwardRef as forwardRef5 } from "react";
function _extends5() {
  _extends5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
var weights5 = /* @__PURE__ */ new Map([
  [
    "regular",
    // eslint-disable-next-line react/jsx-key
    /* @__PURE__ */ React5.createElement("g", {
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2
      }
    }, /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M547.364,1007.44L548.457,460.268L519.29,460.21L518.197,1007.38L547.364,1007.44Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M54.139,250.695L528.213,428.47L538.454,401.16L64.38,223.385L54.139,250.695Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("rect", {
      x: "519.303",
      y: "59.261",
      width: "29.167",
      height: "550.2"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M528.213,665.508L1002.29,843.284L1012.53,815.975L538.454,638.199L528.213,665.508Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M1002.29,223.382L528.216,401.16L538.457,428.47L1012.53,250.692L1002.29,223.382Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M528.213,638.199L54.139,815.976L64.38,843.285L538.454,665.508L528.213,638.199Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M1021.99,829.63L1021.99,237.037L1012.54,223.388L540.115,45.61L534.978,44.676L533.885,44.676L528.77,45.602L54.143,223.38L44.675,237.064L45.781,829.654L55.228,843.275L527.643,1021.05L537.894,1021.06L1012.52,843.286L1021.99,829.63ZM73.86,247.14L74.929,819.526L532.791,991.826L992.823,819.519L992.823,247.131L534.421,74.631L73.86,247.14Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M520.356,51.633L46.835,822L71.683,837.274L545.204,66.906L520.356,51.633Z"
    })), /* @__PURE__ */ React5.createElement("g", {
      transform: "matrix(0.239925,0,0,0.239925,0,0)"
    }, /* @__PURE__ */ React5.createElement("path", {
      d: "M995.005,229.366L520.378,996.709L545.183,1012.05L1019.81,244.708L995.005,229.366Z"
    })))
  ]
]);
var KUBEIcon = /* @__PURE__ */ forwardRef5((props, ref) => /* @__PURE__ */ React5.createElement(IconBase5, _extends5({
  ref
}, props, {
  weights: weights5
})));
KUBEIcon.displayName = "DXOS";
var KUBE_default = KUBEIcon;

// packages/apps/patterns/react-icons/src/icons/MESH.tsx
import { IconBase as IconBase6 } from "@phosphor-icons/react";
import React6, { forwardRef as forwardRef6 } from "react";
function _extends6() {
  _extends6 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
var weights6 = /* @__PURE__ */ new Map([
  [
    "regular",
    /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement("path", {
      d: "M65.743,14.645l58.606,227.928l6.777,-1.742l-58.606,-227.929l-6.777,1.743Z"
    }), /* @__PURE__ */ React6.createElement("path", {
      d: "M127.737,235.515l82.361,-120.117l5.771,3.958l-85.247,124.325l-5.771,-0l-85.244,-124.326l5.772,-3.957l82.358,120.117Z"
    }), /* @__PURE__ */ React6.createElement("path", {
      d: "M127.738,84.021l55.836,-72.385l6.159,1.266l58.607,227.929l-6.159,3.008l-114.443,-148.361l-114.443,148.361l-6.159,-3.008l58.607,-227.929l6.159,-1.266l55.836,72.385Zm-109.585,142.063l105.166,-136.335l-52.583,-68.167l-52.583,204.502Zm114.004,-136.335l105.166,136.335l-52.583,-204.502l-52.583,68.167Z"
    }), /* @__PURE__ */ React6.createElement("path", {
      d: "M182.956,12.902l-58.607,227.929l6.777,1.742l58.607,-227.928l-6.777,-1.743Z"
    }))
  ]
]);
var MESHIcon = /* @__PURE__ */ forwardRef6((props, ref) => /* @__PURE__ */ React6.createElement(IconBase6, _extends6({
  ref
}, props, {
  weights: weights6
})));
MESHIcon.displayName = "DXOS";
var MESH_default = MESHIcon;

// packages/apps/patterns/react-icons/src/logotypes/DXOSHorizontalType.tsx
import React7 from "react";
var defaultSize = "w-[256px] h-[128px]";
var DXOSHorizontalType = ({ className = defaultSize }) => {
  return /* @__PURE__ */ React7.createElement("svg", {
    viewBox: "0 0 2048 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, /* @__PURE__ */ React7.createElement("g", {
    transform: "matrix(0.64,0,0,0.64,62.0285,170.667)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M1191.03,327.748L1191.03,712.923L1272.01,712.923C1300.99,712.923 1327.76,707.978 1352.33,698.101C1376.92,688.223 1397.99,674.728 1415.55,657.617C1433.1,640.492 1446.82,620.193 1456.7,596.707C1466.58,573.233 1471.51,547.888 1471.51,520.658C1471.51,493.011 1466.79,467.438 1457.36,443.952C1447.92,420.491 1434.53,400.179 1417.19,383.055C1399.85,365.943 1378.68,352.448 1353.66,342.558C1328.63,332.693 1300.76,327.748 1270.04,327.748L1191.03,327.748ZM1139.67,280.345L1274,280.345C1311.29,280.345 1345.32,286.492 1376.05,298.773C1406.77,311.079 1433.1,327.975 1455.06,349.476C1477,370.989 1494.01,396.334 1506.08,425.525C1518.14,454.727 1524.19,486.422 1524.19,520.658C1524.19,554.895 1517.93,586.728 1505.42,616.133C1492.91,645.538 1475.57,670.896 1453.41,692.182C1431.24,713.48 1405.01,730.263 1374.72,742.556C1344.44,754.837 1311.52,760.983 1275.97,760.983L1139.67,760.983L1139.67,280.345Z"
  })), /* @__PURE__ */ React7.createElement("g", {
    transform: "matrix(0.64,0,0,0.64,62.0285,170.667)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M1785.58,554.239L1649.95,760.986L1592,760.986L1755.95,514.084L1603.2,280.348L1661.14,280.348L1786.89,470.628L1911.99,280.348L1969.93,280.348L1816.53,510.783L1979.81,760.986L1921.87,760.986L1785.58,554.239Z"
  })), /* @__PURE__ */ React7.createElement("g", {
    transform: "matrix(0.64,0,0,0.64,62.0285,170.667)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M2301.11,718.848C2328.77,718.848 2354.44,713.574 2378.14,703.038C2401.85,692.503 2422.36,678.249 2439.7,660.252C2457.04,642.255 2470.65,621.298 2480.53,597.37C2490.4,573.453 2495.34,547.88 2495.34,520.663C2495.34,493.459 2490.4,467.886 2480.53,443.957C2470.65,420.041 2457.04,399.084 2439.7,381.074C2422.36,363.09 2401.85,348.823 2378.14,338.288C2354.44,327.753 2328.77,322.479 2301.11,322.479C2273.45,322.479 2247.78,327.753 2224.08,338.288C2200.37,348.823 2179.85,363.09 2162.52,381.074C2145.17,399.084 2131.57,420.041 2121.7,443.957C2111.82,467.886 2106.89,493.459 2106.89,520.663C2106.89,547.88 2111.82,573.453 2121.7,597.37C2131.57,621.298 2145.17,642.255 2162.52,660.252C2179.85,678.249 2200.37,692.503 2224.08,703.038C2247.78,713.574 2273.45,718.848 2301.11,718.848M2301.11,767.565C2266.87,767.565 2234.83,761.077 2204.98,748.139C2175.13,735.201 2149.03,717.532 2126.64,695.134C2104.25,672.748 2086.57,646.644 2073.64,616.796C2060.68,586.948 2054.21,554.9 2054.21,520.663C2054.21,486.427 2060.68,454.391 2073.64,424.531C2086.57,394.695 2104.25,368.579 2126.64,346.193C2149.03,323.807 2175.13,306.138 2204.98,293.188C2234.83,280.237 2266.87,273.761 2301.11,273.761C2335.35,273.761 2367.38,280.237 2397.24,293.188C2427.08,306.138 2453.2,323.807 2475.58,346.193C2497.97,368.579 2515.64,394.695 2528.59,424.531C2541.54,454.391 2548.01,486.427 2548.01,520.663C2548.01,554.9 2541.54,586.948 2528.59,616.796C2515.64,646.644 2497.97,672.748 2475.58,695.134C2453.2,717.532 2427.08,735.201 2397.24,748.139C2367.38,761.077 2335.35,767.565 2301.11,767.565"
  })), /* @__PURE__ */ React7.createElement("g", {
    transform: "matrix(0.64,0,0,0.64,62.0285,170.667)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M2802.16,767.565C2763.09,767.565 2729.96,759.774 2702.74,744.18C2675.52,728.611 2652.05,706.984 2632.29,679.337L2675.75,646.416C2691.99,671.433 2710.2,690.1 2730.4,702.381C2750.57,714.674 2774.5,720.82 2802.16,720.82C2817.08,720.82 2830.81,718.519 2843.32,713.902C2855.82,709.299 2866.57,703.038 2875.58,695.134C2884.57,687.242 2891.59,677.693 2896.65,666.5C2901.68,655.307 2904.21,643.128 2904.21,629.962C2904.21,615.038 2900.92,602.53 2894.35,592.424C2887.76,582.332 2878.97,573.668 2868,566.421C2857.03,559.174 2844.52,552.927 2830.48,547.653C2816.41,542.391 2801.93,537.117 2787.02,531.856C2770.33,526.165 2753.99,519.904 2737.96,513.087C2721.94,506.296 2707.68,497.847 2695.18,487.742C2682.66,477.649 2672.46,465.47 2664.56,451.204C2656.65,436.938 2652.71,419.269 2652.71,398.199C2652.71,380.644 2656.43,364.291 2663.9,349.152C2671.36,334.001 2681.67,320.835 2694.85,309.642C2708.01,298.449 2723.58,289.672 2741.58,283.31C2759.58,276.948 2779.12,273.761 2800.19,273.761C2834.42,273.761 2863.4,280.123 2887.1,292.859C2910.8,305.595 2931.43,323.364 2948.98,346.193L2908.16,376.471C2883.57,338.288 2847.36,319.191 2799.53,319.191C2785.92,319.191 2773.41,321.164 2762.01,325.122C2750.57,329.068 2740.61,334.658 2732.04,341.905C2723.48,349.152 2716.79,357.601 2711.96,367.251C2707.13,376.913 2704.71,387.233 2704.71,398.199C2704.71,412.25 2707.9,423.987 2714.26,433.422C2720.62,442.869 2729.08,451.103 2739.62,458.109C2750.15,465.141 2762.33,471.174 2776.16,476.22C2789.98,481.267 2804.35,486.427 2819.28,491.701C2835.95,497.405 2852.42,503.779 2868.66,510.786C2884.9,517.818 2899.49,526.481 2912.45,536.789C2925.38,547.109 2935.92,559.731 2944.05,574.655C2952.16,589.579 2956.23,608.019 2956.23,629.962C2956.23,647.959 2952.61,665.185 2945.37,681.652C2938.12,698.106 2927.69,712.701 2914.09,725.424C2900.48,738.16 2884.24,748.366 2865.37,756.043C2846.49,763.72 2825.42,767.565 2802.16,767.565"
  })), /* @__PURE__ */ React7.createElement("g", {
    transform: "matrix(0.64,0,0,0.64,62.0285,170.667)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M893.472,909.428L555.003,697.888L647.316,570.959L893.472,909.428ZM398.96,570.959L491.273,697.888L152.804,909.428L398.96,570.959ZM152.804,157.226L491.273,368.766L398.96,495.695L152.804,157.226ZM545.277,430.649L619.947,533.333L545.277,636.005L545.277,430.649ZM501.011,636.005L426.329,533.333L501.011,430.649L501.011,636.005ZM647.316,495.695L555.003,368.766L893.472,157.226L647.316,495.695ZM996.346,91.042L966.713,59.259L523.144,336.49L79.563,59.259L49.93,91.042L371.591,533.333L49.93,975.612L79.563,1007.41L523.144,730.164L966.713,1007.41L996.346,975.612L674.685,533.333L996.346,91.042Z"
  })));
};
var DXOSHorizontalType_default = DXOSHorizontalType;

// packages/apps/patterns/react-icons/src/logotypes/DXOSType.tsx
import React8 from "react";
var defaultSize2 = "w-[128px] h-[64px]";
var DXOSType = ({ className = defaultSize2 }) => {
  return /* @__PURE__ */ React8.createElement("svg", {
    viewBox: "0 0 1024 512",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, /* @__PURE__ */ React8.createElement("g", {
    transform: "matrix(1,0,0,1,-21.333,-794.383)"
  }, /* @__PURE__ */ React8.createElement("path", {
    d: "M86.069,949.696L86.069,1150.73L128.337,1150.73C143.46,1150.73 157.438,1148.15 170.261,1143C183.093,1137.84 194.092,1130.8 203.257,1121.86C212.414,1112.93 219.574,1102.34 224.73,1090.08C229.886,1077.83 232.464,1064.59 232.464,1050.39C232.464,1035.95 230,1022.61 225.083,1010.35C220.147,998.094 213.168,987.496 204.117,978.559C195.065,969.622 184.009,962.586 170.958,957.43C157.896,952.274 143.346,949.696 127.306,949.696L86.069,949.696ZM59.259,924.949L129.368,924.949C148.845,924.949 166.604,928.166 182.634,934.573C198.665,940.999 212.414,949.821 223.88,961.03C235.328,972.267 244.207,985.491 250.509,1000.73C256.81,1015.96 259.961,1032.52 259.961,1050.39C259.961,1068.25 256.696,1084.86 250.165,1100.22C243.634,1115.57 234.583,1128.8 223.021,1139.91C211.449,1151.03 197.758,1159.79 181.947,1166.2C166.145,1172.62 148.96,1175.82 130.399,1175.82L59.259,1175.82L59.259,924.949Z"
  })), /* @__PURE__ */ React8.createElement("g", {
    transform: "matrix(1,0,0,1,-21.333,-794.383)"
  }, /* @__PURE__ */ React8.createElement("path", {
    d: "M396.392,1067.91L325.596,1175.82L295.359,1175.82L380.925,1046.95L301.202,924.943L331.44,924.943L397.08,1024.27L462.376,924.943L492.614,924.943L412.538,1045.22L497.77,1175.82L467.532,1175.82L396.392,1067.91Z"
  })), /* @__PURE__ */ React8.createElement("g", {
    transform: "matrix(1,0,0,1,-21.333,-794.383)"
  }, /* @__PURE__ */ React8.createElement("path", {
    d: "M665.476,1153.82C679.912,1153.82 693.317,1151.08 705.681,1145.58C718.055,1140.08 728.758,1132.63 737.818,1123.24C746.86,1113.84 753.963,1102.91 759.119,1090.41C764.275,1077.93 766.853,1064.59 766.853,1050.38C766.853,1036.18 764.275,1022.84 759.119,1010.35C753.963,997.859 746.86,986.927 737.818,977.522C728.758,968.137 718.055,960.68 705.681,955.18C693.317,949.691 679.912,946.941 665.476,946.941C651.039,946.941 637.635,949.691 625.27,955.18C612.897,960.68 602.184,968.137 593.133,977.522C584.082,986.927 576.978,997.859 571.832,1010.35C566.676,1022.84 564.098,1036.18 564.098,1050.38C564.098,1064.59 566.676,1077.93 571.832,1090.41C576.978,1102.91 584.082,1113.84 593.133,1123.24C602.184,1132.63 612.897,1140.08 625.27,1145.58C637.635,1151.08 651.039,1153.82 665.476,1153.82M665.476,1179.26C647.602,1179.26 630.875,1175.88 615.303,1169.12C599.721,1162.37 586.096,1153.13 574.4,1141.46C562.723,1129.76 553.491,1116.13 546.741,1100.55C539.981,1084.97 536.601,1068.24 536.601,1050.38C536.601,1032.52 539.981,1015.79 546.741,1000.21C553.491,984.626 562.723,971.001 574.4,959.315C586.096,947.628 599.721,938.405 615.303,931.645C630.875,924.895 647.602,921.506 665.476,921.506C683.349,921.506 700.067,924.895 715.649,931.645C731.23,938.405 744.855,947.628 756.541,959.315C768.228,971.001 777.451,984.626 784.21,1000.21C790.961,1015.79 794.35,1032.52 794.35,1050.38C794.35,1068.24 790.961,1084.97 784.21,1100.55C777.451,1116.13 768.228,1129.76 756.541,1141.46C744.855,1153.13 731.23,1162.37 715.649,1169.12C700.067,1175.88 683.349,1179.26 665.476,1179.26"
  })), /* @__PURE__ */ React8.createElement("g", {
    transform: "matrix(1,0,0,1,-21.333,-794.383)"
  }, /* @__PURE__ */ React8.createElement("path", {
    d: "M926.997,1179.26C906.603,1179.26 889.303,1175.19 875.105,1167.06C860.898,1158.92 848.639,1147.63 838.328,1133.2L861.013,1116.03C869.491,1129.08 879.001,1138.83 889.541,1145.23C900.072,1151.65 912.561,1154.85 926.997,1154.85C934.778,1154.85 941.939,1153.65 948.479,1151.25C955.01,1148.84 960.614,1145.59 965.312,1141.46C970.009,1137.33 973.675,1132.34 976.311,1126.51C978.936,1120.67 980.263,1114.31 980.263,1107.43C980.263,1099.65 978.545,1093.12 975.108,1087.85C971.67,1082.57 967.088,1078.05 961.359,1074.27C955.63,1070.48 949.1,1067.23 941.777,1064.48C934.435,1061.72 926.882,1058.98 919.091,1056.22C910.384,1053.26 901.848,1049.99 893.494,1046.43C885.121,1042.89 877.683,1038.47 871.153,1033.2C864.622,1027.93 859.294,1021.57 855.17,1014.13C851.045,1006.7 848.992,997.463 848.992,986.464C848.992,977.307 850.931,968.762 854.826,960.857C858.721,952.961 864.106,946.087 870.981,940.243C877.855,934.4 885.98,929.827 895.375,926.495C904.77,923.182 914.967,921.511 925.966,921.511C943.839,921.511 958.953,924.843 971.327,931.488C983.701,938.124 994.461,947.414 1003.63,959.32L982.326,975.121C969.494,955.185 950.589,945.227 925.622,945.227C918.519,945.227 911.988,946.258 906.03,948.33C900.072,950.373 894.869,953.305 890.401,957.076C885.932,960.857 882.438,965.277 879.917,970.309C877.397,975.36 876.136,980.735 876.136,986.464C876.136,993.796 877.798,999.926 881.12,1004.84C884.433,1009.78 888.854,1014.08 894.353,1017.73C899.843,1021.41 906.202,1024.56 913.42,1027.18C920.638,1029.83 928.143,1032.52 935.934,1035.26C944.641,1038.24 953.224,1041.56 961.703,1045.23C970.181,1048.9 977.8,1053.42 984.56,1058.81C991.31,1064.18 996.809,1070.79 1001.05,1078.56C1005.29,1086.36 1007.41,1095.98 1007.41,1107.43C1007.41,1116.83 1005.53,1125.81 1001.75,1134.41C997.965,1143 992.513,1150.62 985.419,1157.25C978.316,1163.92 969.837,1169.24 959.994,1173.24C950.131,1177.25 939.132,1179.26 926.997,1179.26"
  })));
};
var DXOSType_default = DXOSType;

// packages/apps/patterns/react-icons/src/logotypes/DXOSVerticalType.tsx
import React9 from "react";
var defaultSize3 = "w-[128px] h-[128px]";
var DXOSVerticalType = ({ className = defaultSize3 }) => {
  return /* @__PURE__ */ React9.createElement("svg", {
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, /* @__PURE__ */ React9.createElement("g", {
    transform: "matrix(0.731429,0,0,0.731429,121.904,66.1132)"
  }, /* @__PURE__ */ React9.createElement("path", {
    d: "M86.069,949.696L86.069,1150.73L128.337,1150.73C143.46,1150.73 157.438,1148.15 170.261,1143C183.093,1137.84 194.092,1130.8 203.257,1121.86C212.414,1112.93 219.574,1102.34 224.73,1090.08C229.886,1077.83 232.464,1064.59 232.464,1050.39C232.464,1035.95 230,1022.61 225.083,1010.35C220.147,998.094 213.168,987.496 204.117,978.559C195.065,969.622 184.009,962.586 170.958,957.43C157.896,952.274 143.346,949.696 127.306,949.696L86.069,949.696ZM59.259,924.949L129.368,924.949C148.845,924.949 166.604,928.166 182.634,934.573C198.665,940.999 212.414,949.821 223.88,961.03C235.328,972.267 244.207,985.491 250.509,1000.73C256.81,1015.96 259.961,1032.52 259.961,1050.39C259.961,1068.25 256.696,1084.86 250.165,1100.22C243.634,1115.57 234.583,1128.8 223.021,1139.91C211.449,1151.03 197.758,1159.79 181.947,1166.2C166.145,1172.62 148.96,1175.82 130.399,1175.82L59.259,1175.82L59.259,924.949Z"
  })), /* @__PURE__ */ React9.createElement("g", {
    transform: "matrix(0.731429,0,0,0.731429,121.904,66.1132)"
  }, /* @__PURE__ */ React9.createElement("path", {
    d: "M396.392,1067.91L325.596,1175.82L295.359,1175.82L380.925,1046.95L301.202,924.943L331.44,924.943L397.08,1024.27L462.376,924.943L492.614,924.943L412.538,1045.22L497.77,1175.82L467.532,1175.82L396.392,1067.91Z"
  })), /* @__PURE__ */ React9.createElement("g", {
    transform: "matrix(0.731429,0,0,0.731429,121.904,66.1132)"
  }, /* @__PURE__ */ React9.createElement("path", {
    d: "M665.476,1153.82C679.912,1153.82 693.317,1151.08 705.681,1145.58C718.055,1140.08 728.758,1132.63 737.818,1123.24C746.86,1113.84 753.963,1102.91 759.119,1090.41C764.275,1077.93 766.853,1064.59 766.853,1050.38C766.853,1036.18 764.275,1022.84 759.119,1010.35C753.963,997.859 746.86,986.927 737.818,977.522C728.758,968.137 718.055,960.68 705.681,955.18C693.317,949.691 679.912,946.941 665.476,946.941C651.039,946.941 637.635,949.691 625.27,955.18C612.897,960.68 602.184,968.137 593.133,977.522C584.082,986.927 576.978,997.859 571.832,1010.35C566.676,1022.84 564.098,1036.18 564.098,1050.38C564.098,1064.59 566.676,1077.93 571.832,1090.41C576.978,1102.91 584.082,1113.84 593.133,1123.24C602.184,1132.63 612.897,1140.08 625.27,1145.58C637.635,1151.08 651.039,1153.82 665.476,1153.82M665.476,1179.26C647.602,1179.26 630.875,1175.88 615.303,1169.12C599.721,1162.37 586.096,1153.13 574.4,1141.46C562.723,1129.76 553.491,1116.13 546.741,1100.55C539.981,1084.97 536.601,1068.24 536.601,1050.38C536.601,1032.52 539.981,1015.79 546.741,1000.21C553.491,984.626 562.723,971.001 574.4,959.315C586.096,947.628 599.721,938.405 615.303,931.645C630.875,924.895 647.602,921.506 665.476,921.506C683.349,921.506 700.067,924.895 715.649,931.645C731.23,938.405 744.855,947.628 756.541,959.315C768.228,971.001 777.451,984.626 784.21,1000.21C790.961,1015.79 794.35,1032.52 794.35,1050.38C794.35,1068.24 790.961,1084.97 784.21,1100.55C777.451,1116.13 768.228,1129.76 756.541,1141.46C744.855,1153.13 731.23,1162.37 715.649,1169.12C700.067,1175.88 683.349,1179.26 665.476,1179.26"
  })), /* @__PURE__ */ React9.createElement("g", {
    transform: "matrix(0.731429,0,0,0.731429,121.904,66.1132)"
  }, /* @__PURE__ */ React9.createElement("path", {
    d: "M926.997,1179.26C906.603,1179.26 889.303,1175.19 875.105,1167.06C860.898,1158.92 848.639,1147.63 838.328,1133.2L861.013,1116.03C869.491,1129.08 879.001,1138.83 889.541,1145.23C900.072,1151.65 912.561,1154.85 926.997,1154.85C934.778,1154.85 941.939,1153.65 948.479,1151.25C955.01,1148.84 960.614,1145.59 965.312,1141.46C970.009,1137.33 973.675,1132.34 976.311,1126.51C978.936,1120.67 980.263,1114.31 980.263,1107.43C980.263,1099.65 978.545,1093.12 975.108,1087.85C971.67,1082.57 967.088,1078.05 961.359,1074.27C955.63,1070.48 949.1,1067.23 941.777,1064.48C934.435,1061.72 926.882,1058.98 919.091,1056.22C910.384,1053.26 901.848,1049.99 893.494,1046.43C885.121,1042.89 877.683,1038.47 871.153,1033.2C864.622,1027.93 859.294,1021.57 855.17,1014.13C851.045,1006.7 848.992,997.463 848.992,986.464C848.992,977.307 850.931,968.762 854.826,960.857C858.721,952.961 864.106,946.087 870.981,940.243C877.855,934.4 885.98,929.827 895.375,926.495C904.77,923.182 914.967,921.511 925.966,921.511C943.839,921.511 958.953,924.843 971.327,931.488C983.701,938.124 994.461,947.414 1003.63,959.32L982.326,975.121C969.494,955.185 950.589,945.227 925.622,945.227C918.519,945.227 911.988,946.258 906.03,948.33C900.072,950.373 894.869,953.305 890.401,957.076C885.932,960.857 882.438,965.277 879.917,970.309C877.397,975.36 876.136,980.735 876.136,986.464C876.136,993.796 877.798,999.926 881.12,1004.84C884.433,1009.78 888.854,1014.08 894.353,1017.73C899.843,1021.41 906.202,1024.56 913.42,1027.18C920.638,1029.83 928.143,1032.52 935.934,1035.26C944.641,1038.24 953.224,1041.56 961.703,1045.23C970.181,1048.9 977.8,1053.42 984.56,1058.81C991.31,1064.18 996.809,1070.79 1001.05,1078.56C1005.29,1086.36 1007.41,1095.98 1007.41,1107.43C1007.41,1116.83 1005.53,1125.81 1001.75,1134.41C997.965,1143 992.513,1150.62 985.419,1157.25C978.316,1163.92 969.837,1169.24 959.994,1173.24C950.131,1177.25 939.132,1179.26 926.997,1179.26"
  })), /* @__PURE__ */ React9.createElement("g", {
    transform: "matrix(0.731429,0,0,0.731429,121.904,66.1132)"
  }, /* @__PURE__ */ React9.createElement("path", {
    d: "M629.499,392.807L552.936,287.544L833.657,112.096L629.499,392.807ZM833.657,714.096L552.936,538.658L629.499,433.385L833.657,714.096ZM442.011,433.385L518.574,538.658L237.853,714.096L442.011,433.385ZM237.853,112.096L518.574,287.544L442.011,392.807L237.853,112.096ZM547.714,320.932L614.748,413.096L547.714,505.26L547.714,320.932ZM523.844,505.317L456.772,413.096L523.844,320.875L523.844,505.317ZM873.146,59.259L535.76,270.129L198.364,59.259L182.391,76.397L427.26,413.096L182.391,749.795L198.364,766.933L535.76,556.063L873.146,766.933L889.119,749.795L644.25,413.096L889.119,76.397L873.146,59.259Z"
  })));
};
var DXOSVerticalType_default = DXOSVerticalType;
export {
  DXNS_default as DXNS,
  DXOS_default as DXOS,
  DXOSHorizontalType_default as DXOSHorizontalType,
  DXOSType_default as DXOSType,
  DXOSVerticalType_default as DXOSVerticalType,
  ECHO_default as ECHO,
  HALO_default as HALO,
  KUBE_default as KUBE,
  MESH_default as MESH
};
//# sourceMappingURL=index.mjs.map
